import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { IconButtonVariant } from "@styleguide";
import { ModalAction } from "@styleguide";
import { useState } from "react";

export const EditActionButton = ({
  isActionDashboard = false,
  action,
  onCloseModal,
  refreshActionList,
  onButtonClick,
  overrideSubmit,
  size = "medium",
  disableCandidateField = false,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => {
    if (typeof onButtonClick === "function") {
      onButtonClick();
    }
    setOpenModal(false);
  };

  const handleSubmit = (action) => {
    handleClose();
    if (typeof refreshActionList === "function") {
      refreshActionList();
    }
    onCloseModal(action);
  };

  return (
    <>
      <IconButtonVariant
        size={size}
        variant="elevated"
        onClick={() => {
          setOpenModal(true);
          if (typeof onButtonClick === "function") {
            onButtonClick();
          }
        }}
      >
        <CreateOutlinedIcon fontSize="small" color="primary" />
      </IconButtonVariant>
      <ModalAction
        open={openModal}
        title="Modification de l'action"
        action={action}
        options={{
          hideCandidateField: !isActionDashboard,
          hideOwnerField: isActionDashboard,
          disableCandidateField,
        }}
        {...(overrideSubmit
          ? {
              overrideSubmit: (formData) => {
                overrideSubmit(formData);
                handleClose();
              },
            }
          : { onSubmit: handleSubmit })}
        onClose={handleClose}
      />
    </>
  );
};
